import { storeToRefs } from "pinia";
import { useAuthStore } from "@/stores/auth.store.js";

export const requiredAuthMiddleware = (to, from, next) => {
  const authStore = useAuthStore();
  const { isAuthenticated } = storeToRefs(authStore);
  if (to.meta.base !== "auth" && !isAuthenticated) return next({ to: "/" });
  next();
};
